// create existence flag for each piece of store data
// makes it easier to debug timing issues in App.tsx

export const isGAConfigFetched = state => {
  return state.analytics !== null;
};

export const getShowAnalytics = state => state.analytics;
